"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import useOnScreen from "@/src/hooks/useOnScreen";
import { fetchLogo } from "@/src/api";
import { LogoData } from "@/src/api/fetchLogo/types";
import { LogoProps } from "./types";

export function Logo({ center = false, noRedirect = false }: LogoProps) {
  const { ref, isIntersecting } = useOnScreen<HTMLDivElement>(0.1, true);
  const [logo, setLogo] = useState<LogoData | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadLogo = async () => {
      try {
        const logoData = await fetchLogo();
        setLogo(logoData.acf.logo);
      } catch (error) {
        console.error("Failed to fetch logo:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadLogo();
  }, []);

  return (
    <div
      ref={ref}
      className={`header-logo font-bold text-xl transition-all duration-700 ease-in-out ${
        isIntersecting ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
      } ${center ? "flex justify-center" : ""}`}
    >
      {noRedirect ? (
        isLoading ? (
          <span>Loading...</span>
        ) : logo ? (
          <Image
            src={logo.url}
            alt={logo.alt || "ECOSHOP Logo"}
            width={325}
            height={49}
            className={`w-[150px] sm:w-[200px] md:w-[200px] lg:w-[325px] xl:w-[325px] h-auto ${
              center ? "mx-auto" : ""
            }`}
          />
        ) : (
          <span>ECOSHOP LOGO</span>
        )
      ) : (
        <Link href="/">
          {isLoading ? (
            <span>Loading...</span>
          ) : logo ? (
            <Image
              src={logo.url}
              alt={logo.alt || "ECOSHOP Logo"}
              width={325}
              height={49}
              className={`w-[150px] sm:w-[200px] md:w-[200px] lg:w-[325px] xl:w-[325px] h-auto ${
                center ? "mx-auto" : ""
              }`}
            />
          ) : (
            <span>ECOSHOP LOGO</span>
          )}
        </Link>
      )}
    </div>
  );
}
